import { Injectable } from '@angular/core';

import { AuthStore } from '@store';

import { BaseApiPickerImpl } from '../base.api-picker';

import { DashboardMockApi } from './dashboard.mock.api';
import { DashboardApi } from './dashboard.api';

@Injectable({ providedIn: 'root' })
export class DashboardApiPicker extends BaseApiPickerImpl<DashboardApi | DashboardMockApi> {
  constructor(
    protected authStore: AuthStore,
    protected realApi: DashboardApi,
    protected mockApi: DashboardMockApi
  ) {
    super(authStore, realApi, mockApi);
  }
}
